import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './ProductDetail.css';

function ServiceProjectDetail() {
  const { slug, project } = useParams();
  console.log("Service:", slug, "Project:", project);

  // Sample data; you can expand this as needed
  const projectData = {
    dasnac: {
      name: 'DASNAC',
      desc: 'A premium real estate development showcased with immersive ArchViz technology.',
      photos: [1, 2, 3].map(n => `/img/products/archviz-hq/dasnac/${n}.jpg`),
      video: '/img/products/archviz-hq/dasnac/video.mp4',
    },
    'dasnac-2': {
      name: 'DASNAC 2',
      desc: 'The second phase of DASNAC visualization with extended interactivity.',
      photos: [1, 2].map(n => `/img/products/archviz-hq/dasnac-2/${n}.jpg`),
      video: '/img/products/archviz-hq/dasnac-2/video.mp4',
    },
    'asf-vrbuilder': {
  name: 'ASF Insignia Experience Centre',
  desc: `
    A state-of-the-art Experience Centre to cater to exclusive clients of ASF Group at their campus in Gwal Pahari, Gurgaon. The centre is designed as an experience in itself. As the Lift Lobby opens into the welcoming lounge, the guests can have an overview of the ASF Group and its various projects on the interactive screens installed.
    <br/><br/>
    The design features a continuous serpentine curved wall clad in wood that segregates open Lounge areas from the closed rooms. A semi enclosed Presentation area in the centre forms the focal point, equipped with Media Wall and Architectural Model of the Campus on Hydraulic podium, where the high profile presentation of the project is given to the clients.
    <br/><br/>
    This then leads to the Board Room with VC Facility. The lounge opens into a viewing balcony for the clients to experience the campus physically. The space is designed in a way that it guides the movement of visitors in a smooth sequential manner with one space flowing into the other.
    <br/><br/>
    <ul>
      <li><strong>Client:</strong> ASF Insignia</li>
      <li><strong>Tasks:</strong> Design</li>
      <li><strong>Location:</strong> Gwal Pahari, Gurgaon</li>
      <li><strong>Type:</strong> Experience Centre</li>
      <li><strong>Area:</strong> 5,000 sqft</li>
      <li><strong>Status:</strong> On site</li>
    </ul>
  `,
  photos: [1, 2, 3, 4, 5, 6, 7].map(
    (n) => `/img/products/vr-builder/asf/images/${n}.jpg`
  ),
  video: null // if you later have a video, replace `null` with the URL
},
'bmr-vrbuilder': {
  name: 'BMR Advisors',
  desc: `
    <h2>Project Detail</h2>
    <p>
      In line with their recent corporate re-branding, design of the new BMR office is centered around a simplistic monochrome theme, coupled with their corporate colours to achieve a light, airy, modern outlook for the whole office. Highlight of design is that the new and the existing elements come together seamlessly to create an economical workspace that is professional, inviting, functional and efficient and caters to the varied functional requirements to support future business.<br><br>
      The not so big reception area looks spacious and inviting, and is the core of the office as this is where the various zones. The two wings of the L-Shaped building form the Direct Tax and Indirect Tax Workspaces, complete with their Partner Cabins, combination of Workstations for the staff and ample storage along the passages. The double height quadrant shape Partner Lounge and the Board Room with its acoustic movable wall, form the focus of the client area, which connects the two wings. The BMR Legal office is accessed directly from the Reception Area and functions as a self-sufficient entity in itself.<br><br>
      The utility passage, with BMR Letter wall and feature elements, separates the support functions from the main workspace visually while providing easy access to these areas.  The Main Pantry area serves dual function as a break-out space and a training area where small get- togethers and training sessions can take place.<br><br>
      The 72 seater cafe on the terrace takes advantage of the pleasant Bangalore weather.
    </p>
    <ul class="customlist">
      <li><strong>Client:&nbsp;</strong>BMR Advisors</li>
      <li><strong>Tasks:&nbsp;</strong>Design &amp; Build</li>
      <li><strong>Location:&nbsp;</strong>Prestige Nebula, Infantry Road, Bengaluru</li>
      <li><strong>Type:&nbsp;</strong>Commercial Interiors</li>
      <li><strong>Area:&nbsp;</strong>25,000 sqft</li>
      <li><strong>Status:&nbsp;</strong>Completed</li>
    </ul>
  `,
  photos: Array.from({ length: 10 }, (_, i) => `/img/products/vr-builder/bmr/images/${i + 1}.jpg`),
  video: null
},
'hill-international-vrbuilder': {
  name: 'Hill International',
  desc: `
    <h3>Project Detail</h3>
    <p>
      A small corporate office space in Building No. 9 in DLF Cyber City, set up to mark the firm’s presence in India. A simple, elegant Reception Lobby in line with the design guidelines for their offices worldwide, has the large high end 24 seater Board Room on one side. The other side of the reception area leads to the office space through a well-lit space that gives access to the washrooms and pantry area, utilized as a break-out space and transition between the reception and workspace. The workspace in itself houses a few cabins and L-shaped workstations. The office is designed as a functional, contemporary and aesthetic workspace.
    </p>
    <ul class="customlist">
      <li><strong>Client:&nbsp;</strong>Hill International</li>
      <li><strong>Tasks:&nbsp;</strong>Design &amp; Build</li>
      <li><strong>Location:&nbsp;</strong>DLF Cyber City, Gurgaon</li>
      <li><strong>Type:&nbsp;</strong>Commercial Interior</li>
      <li><strong>Area:&nbsp;</strong>5,000 sqft</li>
      <li><strong>Status:&nbsp;</strong>Completed</li>
    </ul>
  `,
  photos: [1, 2, 3, 4].map(n => `/img/products/vr-builder/hill-international/images/${n}.jpg`),
  video: null
},
'indigo-vrbuilder': {
  name: 'IndiGo Airlines',
  desc: `
    <h3>Project Detail</h3>
    <p>
      A new training facility for the youthful Indigo Airlines crew, with a complex brief to house multiple varied functions. Highlights of the Project being,The Double Height Reception Area, carved out by removing the slab, with a 12’ Indigo airplane model suspended from the ceiling, The Graduation Room designed as an amphitheatre that serves as a multifunction space, and The two Aircraft Model Training Rooms with their shape, windows, overhead bins, galleys and seats that complete the look and feel of an aircraft. Diverse theme based Breakouts on each of the Typical Training Floors are the hotspots that create interest and differentiate the otherwise very functional Floors with 6-9 Training rooms each. The passages on these floors are designed as runways and the washrooms have cubicles inspired from the aircraft toilets. State-of-the-art technology has been used in the entire facility. The corporate floor houses high-end Board Room overlooking a terrace garden.The 150 seat cafeteria, with warm lighting and rustic furniture giving it a feel of a cosy restaurant, along with Gym and Karaoke Room is located in the Basement. The terrace on 7th Floor is utilized as an informal get together space with outdoor furniture, deck flooring, pergolas and Projection facility which allows the space to be used for presentations as well. A gazebo for meditation sits in one corner of the terrace.
    </p>
    <ul class="customlist">
      <li><strong>Client:&nbsp;</strong>IndiGo</li>
      <li><strong>Tasks:&nbsp;</strong>Design and Build</li>
      <li><strong>Location:&nbsp;</strong>Sector 44, Gurgaon</li>
      <li><strong>Type:&nbsp;</strong>Commercial Interiors</li>
      <li><strong>Area:&nbsp;</strong>85,000 sqft</li>
      <li><strong>Status:&nbsp;</strong>Completed</li>
    </ul>
  `,
  photos: [1, 2, 3, 4, 5, 6, 7].map(n => `/img/products/vr-builder/indigo/photos/${n}.jpg`),
  images: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(n => `/img/products/vr-builder/indigo/images/${n}.jpg`),
  video: null
},

'interocean-vrbuilder': {
  name: 'Interocean Shipping',
  desc: `
    <h3>Project Detail</h3>
    <p>
      A modern, corporate office spread out on 3 floors of a stand-alone building, for one of the leading shipping companies, as part of their expansion to accommodate around 350 seats. The new office is designed to create an economical workspace that is spacious, functional, sustainable and Vaastu compliant, with clean straight lines and simplistic approach for a very design conscious client.<br><br>
      The building lobby on ground floor gives access to a warm and welcoming Reception area designed to ---------------. The ground floor is more of a public space with visitor meeting rooms as part of the Reception area, the large Cafetaria that caters to the staff, Locker room and the HR Department.<br><br>
      The levels above are large open workspaces with linear workstations to give a neat, contemporary look to the rectangular floor with ample light coming in. Central Collaboration spaces are provided as part of the open office. Conference Rooms with acoustical movable walls, and Directors Office are placed towards the shorter side of the floor plate. The CEO office with its anteroom, dining space and washroom, located on the southwest side on first floor, is elegantly designed in accordance with client’s aesthetic sensibilities. The second floor houses a large archive Store, Server and UPS Rooms and a future Gymnasium.<br><br>
      The wellbeing of employees is specially emphasized by use of Air Purifiers for the entire building, well lit workspaces and use of sustainable materials and technology.
    </p>
    <ul class="customlist">
      <li><i class="fa fa-caret-right"></i><strong>Client:&nbsp;</strong>Interocean Shipping</li>
      <li><i class="fa fa-caret-right"></i><strong>Tasks:&nbsp; </strong>Design</li>
      <li><i class="fa fa-caret-right"></i><strong>Location: &nbsp;</strong>MCIE, Delhi</li>
      <li><i class="fa fa-caret-right"></i><strong>Type:&nbsp; </strong>Commercial Interiors</li>
      <li><i class="fa fa-caret-right"></i><strong>Area: &nbsp;</strong>50,000 sqft</li>
      <li><i class="fa fa-caret-right"></i><strong>Status:&nbsp; </strong>On site</li>
    </ul>
  `,
  photos: Array.from({ length: 10 }, (_, i) => `/img/products/vr-builder/interocean/images/${i + 1}.jpg`),
  images: [], // not needed, but included for safety
  video: null
},
'quikr-vrbuilder': {
  name: 'Quikr',
  desc: `
    <h3>Project Detail</h3>
    <p>
      Quikr’s new campus in Bangalore is an old textile factory comprising of different buildings that can be utilised for facilities of an A class office. The campus is a beautiful 4 acres, nicely tucked away, pocket of land behind Manyata Tech Park in Hebbal. The design philosophy was to retain the essence of various buildings and campus, by keeping the surfaces exposed – vertical as well as horizontal, enhancing the spaces by using as much glass as possible and using materials/ finishes to compliment the existing structures. The main building is a three floor industrial shed with a square floor plate and numerous columns. Reception on the Ground floor opens out onto a three storey atrium carved out in the middle to get in light to the core of the building. The atrium is highlighted by its feature staircase that connects the three levels, a huge Green Q printed in the concrete floor and skylight created in the existing sloping roof. Small meeting rooms distributed in the open workspace are glass cubes with floating roof. The second floor houses a large Board Room and the CEO Office with solid wood customized furniture to go with the overall ambience. The floor to ceiling heights, structural spans and truss roofing systems all enhance the feeling of space, openness and natural light. The canteen shed for mill workers is converted into an open cafeteria for staff, equipped with a cooking kitchen, vending counters and tuckshops while retaining the original structure and open feel of the shed.
    </p>
    <ul class="customlist">
      <li><i class="fa fa-caret-right"></i><strong>Client:&nbsp;</strong>Quikr</li>
      <li><i class="fa fa-caret-right"></i><strong>Tasks:&nbsp; </strong>Design and Build</li>
      <li><i class="fa fa-caret-right"></i><strong>Location: &nbsp;</strong>Rachanahalli, Bengaluru</li>
      <li><i class="fa fa-caret-right"></i><strong>Type:&nbsp; </strong>Commercial Interior &amp; Campus Upgradation</li>
      <li><i class="fa fa-caret-right"></i><strong>Area: &nbsp;</strong>1,00,000 sqft</li>
      <li><i class="fa fa-caret-right"></i><strong>Status:&nbsp; </strong>On going</li>
    </ul>
  `,
  photos: Array.from({ length: 6 }, (_, i) => `/img/products/vr-builder/quikr/images/${i + 1}.jpg`),
  images: [],
  video: null
},
'quint1-vrbuilder': {
  name: 'Quint 1',
  desc: `
    <h3>Project Detail</h3>
    <p>
      A youthful, cheerful, productive and non corporate workspace had to be achieved for Quintillion Media Pvt.Ltd, a Mobile first Digital News company for their new corporate office in NOIDA. We came up with the concept of a dynamic Newstreet linking the bridge feature housing the Moroccan themed café overlooking the River Yamuna to the big terrace where we built the conference room, support function and the Diner. Along the way some beautifully crafted spaces like the Amphitheatre, huddle spaces, library, collaboration zones were placed. Tablets were hung from the ceiling along the Newstreet. The open workspaces were designed in a very non cube like manner with task lighting and ambient lighting with black and white surfaces for writing and collaborating.
    </p>
    <ul class="customlist">
      <li><i class="fa fa-caret-right"></i><strong>Client:&nbsp; </strong>Quint 1</li>
      <li><i class="fa fa-caret-right"></i><strong>Tasks:&nbsp; </strong> Concept, Design &amp; Development</li>
      <li><i class="fa fa-caret-right"></i><strong>Location:&nbsp; </strong>Noida</li>
      <li><i class="fa fa-caret-right"></i><strong>Type:&nbsp; </strong> Commercial Interiors</li>
    </ul>
  `,
  photos: Array.from({ length: 5 }, (_, i) => `/img/products/vr-builder/quint1/images/${i + 1}.jpg`),
  images: [],
  video: null
},
'quint2-vrbuilder': {
  name: 'Quint 2',
  desc: `
    <h3>Project Detail</h3>
    <p>
      Inheriting an already done up space to plan the new office was not easy and in order to break away from the usual, a totally out of the box approach was considered. We broke the symmetry thereby giving a feeling of spaciousness and created triangular pockets for collaboration along the North glazing in the News room. The ceiling was taken off to create an open volume effect. Working with eclectic accessories handpicked from antique shops, different materials like exposed brickwork, cork, graphics, film patterns, neon signages and different light fixtures the final result is a warm, open, friendly and totally WOW look and feel most unlike a regular corporate office.
    </p>
    <ul class="customlist">
      <li><i class="fa fa-caret-right"></i><strong>Client:&nbsp; </strong>Quint 2</li>
      <li><i class="fa fa-caret-right"></i><strong>Tasks:&nbsp; </strong>Design &amp; Build</li>
      <li><i class="fa fa-caret-right"></i><strong>Location:&nbsp; </strong>Noida</li>
      <li><i class="fa fa-caret-right"></i><strong>Type:&nbsp; </strong>Commercial Interiors</li>
    </ul>
  `,
  photos: Array.from({ length: 15 }, (_, i) => `/img/products/vr-builder/quint2/images/${i + 1}.jpg`),
  images: [],
  video: null
},

'quint3-vrbuilder': {
  name: 'Quint 3',
  desc: `
    <h3>Project Detail</h3>
    <p>
      A richer, more corporate look and yet not deviating totally from the fun workplace on the lower floor, this floor was designed for the management team. A client lounge and a fully equipped board room was placed along with the Founder/ Chairman and other management cabins. This floor also houses the main studio and the technical areas. Open office areas and small coffee lounges open into an outdoor space from where one gets the most spectacular view of the city.
    </p>
    <ul class="customlist">
      <li><i class="fa fa-caret-right"></i><strong>Client:&nbsp; </strong>Quint 3</li>
      <li><i class="fa fa-caret-right"></i><strong>Tasks:&nbsp; </strong> Design &amp; Build</li>
      <li><i class="fa fa-caret-right"></i><strong>Location:&nbsp; </strong>Noida</li>
      <li><i class="fa fa-caret-right"></i><strong>Type:&nbsp; </strong> Commercial Interiors</li>
    </ul>
  `,
  photos: Array.from({ length: 5 }, (_, i) => `/img/products/vr-builder/quint3/images/${i + 1}.jpg`),
  images: [],
  video: null
},

'bloomberg-quint-vrbuilder': {
  name: 'Bloomberg Quint',
  desc: `
    <h3>Project Detail</h3>
    <p>
      Bloomberg | Quint is a multiplatform, Indian business and financial news company that combines Bloomberg’s global leadership in business and financial news and data, with Quintillion Media’s deep expertise in the Indian market and digital news delivery.<br><br>
      The design of the new office for BQ in Mumbai is a young dynamic newsroom with open studios. In line with their recent JV, design of the new BQ office merges the corporate, sophisticated look of Bloomberg offices with the eclectic touch of The Quint. The space is planned with a street concept of open studios forming the nodes, around which the workstations are arranged keeping in mind the camera angles and movement, in the newsroom. Acoustics form an important parameter for space planning as the noise levels need to be controlled in the workspace. Return air ducts, used of acoustic cladding materials on solid partitions, segregation of noise generating activities, carpet floor help in achieving this. White worktops on a neutral grey carpet floor with bright colour accents in the floor as well as understructure of the desks make the space vibrant and contemporary, coupled with exposed ceilings and steel finish ducts which complete the look. Use of light pillars for wayfinding also gives a bright glow to the office. The cafeteria, designed as an informal space with the use of bright colours, benches and stools for seating, exposed ceilings and hanging lights, is separated from the newsroom to control the noise levels. It also functions as a multipurpose space.<br><br>
      Technical areas like the CAR, PCR, MCR, Server Room, etc. form a major part of the facility and are clubbed together in one part of the floor plate.
    </p>
    <ul class="customlist">
      <li><i class="fa fa-caret-right"></i><strong>Client:&nbsp; </strong>Bloomberg Quint</li>
      <li><i class="fa fa-caret-right"></i><strong>Tasks:&nbsp; </strong> Design &amp; Build</li>
      <li><i class="fa fa-caret-right"></i><strong>Location:&nbsp; </strong>India Bulls</li>
      <li><i class="fa fa-caret-right"></i><strong>Type:&nbsp; </strong> Commercial Interiors</li>
      <li><i class="fa fa-caret-right"></i><strong>Area:&nbsp; </strong> 25,000 sqft</li>
      <li><i class="fa fa-caret-right"></i><strong>Status:&nbsp; </strong> on site</li>
    </ul>
  `,
  photos: Array.from({ length: 9 }, (_, i) => `/img/products/vr-builder/bloomberg-quint/images/${i + 1}.jpg`),
  images: [],
  video: null
},


  };

  const projectInfo = projectData[project];
  const isIndigo = project === 'indigo-vrbuilder';

  const defaultTab = projectInfo?.photos?.length > 0 ? 'photos' : 'videos';
  const [activeTab, setActiveTab] = useState(defaultTab);
  const [hero, setHero] = useState(null);
  // const [videoIndex, setVideoIndex] = useState(0);

   useEffect(() => {
    if (projectInfo) {
      const initialHero =
        (activeTab === 'images' && isIndigo
          ? projectInfo.images?.[0]
          : projectInfo.photos?.[0]) || null;

      setHero(initialHero);
    }
  }, [slug, project, activeTab]);

  if (!projectInfo) {
   return (
      <>
        <Navbar />
        <main className="pd-container container">
          <h2>Project not found</h2>
          <p>This service project doesn't exist.</p>
        </main>
        <Footer />
      </>
    );
  }

  const navTrail = [
    { label: 'Home', href: '/' },
    { label: 'Services', href: '/services' },
    { label: slug.replace('-', ' '), href: `/services/${slug}` },
    { label: projectInfo.name }
  ];

  // Select media set
  const mediaSet =
    activeTab === 'images' && isIndigo
      ? projectInfo.images
      : projectInfo.photos;

  return (
    <>
      <Navbar />
      <main className="pd-container container">
        {/* ► breadcrumb */}
        <ol className="nav-path">
          {navTrail.map((item, i) => (
            <li key={i}>
              {item.href ? <a href={item.href}>{item.label}</a> : item.label}
              {i < navTrail.length - 1 && <span> &gt; </span>}
            </li>
          ))}
        </ol>

        {/* ► title */}
        <h2 className="portfolio-header header-shadow text-center">
          {projectInfo.name}
        </h2>

        {/* ► tabs */}
        <ul className="pd-tabs">
          <li
            className={activeTab === 'photos' ? 'active' : ''}
            onClick={() => setActiveTab('photos')}
          >
            Photos
          </li>
          {isIndigo && (
            <li
              className={activeTab === 'images' ? 'active' : ''}
              onClick={() => setActiveTab('images')}
            >
              Images
            </li>
          )}
        </ul>

        {/* ► main content */}
        <section className="pd-content">
          {/* ► media viewer */}
          <div className="media-container">
            {hero && (
              <img src={hero} alt={projectInfo.name} className="pd-media" />
            )}
          </div>

          {/* ► thumbnails */}
          {mediaSet?.length > 0 && (
            <div className="thumb-strip">
              {mediaSet.map((src, i) => (
                <button
                  key={i}
                  className={`thumb ${hero === src ? 'active' : ''}`}
                  onClick={() => setHero(src)}
                >
                  <img src={src} alt={`thumb-${i}`} />
                </button>
              ))}
            </div>
          )}

          {/* ► description */}
          <div
            className="project-desc"
            dangerouslySetInnerHTML={{ __html: projectInfo.desc }}
          />
        </section>
      </main>
      <Footer />
    </>
  );
}

export default ServiceProjectDetail;